module.exports = {
          srcSet: __webpack_public_path__ + "1527eabb91f8c24bd14cfcf6bc7f98b3-95.png"+" 95w",
          images:[ {path: __webpack_public_path__ + "1527eabb91f8c24bd14cfcf6bc7f98b3-95.png",width: 95,height: 90}],
          src: __webpack_public_path__ + "1527eabb91f8c24bd14cfcf6bc7f98b3-95.png",
          toString:function(){return __webpack_public_path__ + "1527eabb91f8c24bd14cfcf6bc7f98b3-95.png"},
          
          width: 95,
          height: 90
        }